// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__yKi_v","headerDesktop":"Header_headerDesktop__yAhgF","headerMobile":"Header_headerMobile__KvK1Z","skip":"Header_skip__RvQh5"};